module.exports = __webpack_public_path__ + "img/Ashley.c93b61b4.png";